import { alignItems, width } from "@mui/system";
import { LuSearch, BsThreeDots, LuChevronDown } from "@/Components/Icons/Icons";

export default {
  row1: [
    {
      column: "column1",
      columnWidth: "46%",
      rows: {
        row1: [
          {
            name: "importerId",
            label: "Importer",
            component: "text-field",
            placeholder: "Select Importer",
            width: "90%",
            type: "autocomplete",
            endpoint: "getCustomers",
            icon: LuSearch,
            autofillTargets: {
              importerAddressId: "address",
              importerAddress: "addressLine",
              importerGeneralState: "state",
              importerGeneralBranchSNO: "branchNo",
              importerGeneralIECodeNo: "ieCodeNo",
            },
            required: true,
            endPointWithId : "getCustomersAddress"
          },
          {
            name: "New",
            label: "New",
            component: "outlinebutton",
            action: "GoToCreateCustomer",
            variant: "bodySmallMedium",
            width: "10%",
            sx: {
              mt: "32px",
            },
          },
        ],
        row2: [
          {
            name: "importerAddressId",
            label: "Address",
            component: "dropdown",
            width: "100%",
            type: "autocomplete",
            autofillTargets: {
              importerAddress: "addressLine",
              importerGeneralState: "state",
            },
          },
        ],
        row3: [
          {
            name: "importerAddress",
            component: "textarea",
            width: "100%",
            height: 100,
            sx: {
              borderRadius: 10,
            },
            disabled: true,
          },
        ],
        row4: [
          {
            name: "importerGeneralBranchSNO",
            label: "Branch SNO",
            component: "text-field",
            width: "35%",
            disabled: true,
          },
          {
            name: "importerGeneralState",
            label: "State",
            component: "text-field",
            width: "65%",
            disabled: true,
          },
        ],
        row5: [
          {
            name: "importerGeneralIECodeNo",
            label: "IE Code",
            component: "text-field",
            width: "50%",
            disabled: true,
          },
          {
            name: "importerGeneralADCode",
            label: "AD Code",
            component: "text-field",
            endpoint : "getAdCodeMaster",
            type : "autocomplete",
             width: "50%",
          },
        ],
        row6: [
          {
            name: "importerGeneralRegnNoType",
            label: "Regn.No",
            options: [
              {label: "GSTIN",value: "GSTIN",},
              {label: "GSTIN (Govt)",value: "GSTINGovernment",},
              { label: "GSTIN (Diplomats)", value: "GSTINofDiplomats" },
              {
                label: "GSTIN of Non-Resident Taxable Person",
                value: "GSTINofNon-ResidentTaxablePerson",
              },
              { label: "VAT", value: "VATNumber" },
              { label: "CST", value: "CSTNumber" },
              { label: "ST", value: "STNumber" },
              { label: "Central ExciseRegn No", value: "CentralExciseRegnNo" },
              { label: "Aadhar Number", value: "AadharNumber" },
              { label: "Passport Number", value: "PassportNumber" },
              { label: "PAN Number", value: "PANNumber" },
              { label: "TIN Number", value: "TINNumber" },
            ],
            component: "dropdown",
            endIconName: "LuChevronDown",
            width: "40%"


          },
          {
            name: "importerGeneralRegnNumber",
            component: "text-field",
            // icon: LuSearch,
            width: "20%"
          },
          {
            name: "importerGeneralRegnNumberState",
            component: "dropdown",
            endIconName: "LuChevronDown",
            width: "30%",
            disabled: true,   // ⭐ start disabled
            options: [
              { label: "01 - JAMMU & KASHMIR", value: "01 - JAMMU & KASHMIR" },
              { label: "02 - HIMACHAL PRADESH", value: "02 - HIMACHAL PRADESH" },
              { label: "03 - PUNJAB", value: "03 - PUNJAB" },
              { label: "04 - CHANDIGARH", value: "04 - CHANDIGARH" },
              { label: "05 - UTTARAKHAND", value: "05 - UTTARAKHAND" },
              { label: "06 - HARYANA", value: "06 - HARYANA" },
              { label: "07 - DELHI", value: "07 - DELHI" },
              { label: "08 - RAJASTHAN", value: "08 - RAJASTHAN" },
              { label: "09 - UTTAR PRADESH", value: "09 - UTTAR PRADESH" },
              { label: "10 - BIHAR", value: "10 - BIHAR" },
              { label: "11 - SIKKIM", value: "11 - SIKKIM" },
              { label: "12 - ARUNACHAL PRADESH", value: "12 - ARUNACHAL PRADESH" },
              { label: "13 - NAGALAND", value: "13 - NAGALAND" },
              { label: "14 - MANIPUR", value: "14 - MANIPUR" },
              { label: "15 - MIZORAM", value: "15 - MIZORAM" },
              { label: "16 - TRIPURA", value: "16 - TRIPURA" },
              { label: "17 - MEGHALAYA", value: "17 - MEGHALAYA" },
              { label: "18 - ASSAM", value: "18 - ASSAM" },
              { label: "19 - WEST BENGAL", value: "19 - WEST BENGAL" },
              { label: "20 - JHARKHAND", value: "20 - JHARKHAND" },
              { label: "21 - ODISHA", value: "21- ODISHA" },
              { label: "22 - CHATTISGARH", value: "22 - CHATTISGARH" },
              { label: "23 - MADHYA PRADESH", value: "23 - MADHYA PRADESH" },
              { label: "24 - GUJARAT", value: "24 - GUJARAT" },
              { label: "25 - DAMAN & DIU", value: "25 - DAMAN & DIU" },
              { label: "26 - DADRA AND NAGAR HAVELI AND DAMAN AND DIU", value: "26 - DADRA AND NAGAR HAVELI AND DAMAN AND DIU" },
              { label: "27 - MAHARASHTRA", value: "27 - MAHARASHTRA" },
              { label: "29 - KARNATAKA", value: "29 - KARNATAKA" },
              { label: "30 - GOA", value: "30 - GOA" },
              { label: "31 - LAKSHADWEEP", value: "31 - LAKSHADWEEP" },
              { label: "32 - KERALA", value: "32 - KERALA" },
              { label: "33 - TAMIL NADU", value: "33 - TAMIL NADU" },
              { label: "34 - PUDUCHERRY", value: "34 - PUDUCHERRY" },
              { label: "35 - ANDAMAN & NICOBAR", value: "35 - ANDAMAN & NICOBAR" },
              { label: "36 - TELANGANA", value: "36 - TELANGANA" },
              { label: "37 - ANDHRA PRADESH", value: "37 - ANDHRA PRADESH" },
              { label: "38 - LADAKH", value: "38 - LADAKH" }
            ],
            dependsOn: "importerGeneralRegnNoType",
            dependsValue: ["VATNumber","CSTNumber","STNumber","CentralExciseRegnNo","AadharNumber","PassportNumber","PANNumber","TINNumber"],
          }
        ],
        row7: [
          {
            name: "importerGeneralRefNo",
            label: "Importer Ref No.",
            component: "text-field",
          },
        ],
        row8: [
          {
            name: "importerGeneralAirCustodian",
            label: "Air Custodian",
            component: "text-field",
            endIconName: "LuSearch",
          },
        ],
        row9: [
          {
            name: "importerGeneralPortOfShipment", 
            label: "Port Of Shipment",
            component: "text-field",
            endIconName: "LuSearch",
            // type: "autocomplete",
            // endpoint: "getPorts",
            // useParams : "general.exportTransportMode",
            // endpointWithParams : "portType",
          },
        ],
        row10: [
          {
            name: "importerGeneralCountryOfShipment",
            label: "Country Of Shipment",
            component: "text-field",
            endIconName: "LuSearch",
            // type: "autocomplete",
            // endpoint: "getCountry",

          },
        ],
        row11: [
          {
            name: "importerGeneralCountryOfOrigin",
            label: "Country Of Origin",
            component: "text-field",
            endIconName: "LuSearch",
            // type: "autocomplete",
            // endpoint: "getCountry",

          },
        ],
        row12: [
          {
            name: "importerGeneralFinalDestination",
            label: "Final Destination",
            component: "text-field",
            endIconName: "LuSearch",
            // type: "autocomplete",
            // endpoint: "getPorts",
            // useParams : "general.exportTransportMode",
            // endpointWithParams : "portType",
          },
        ],
        row13: [
          {
            name: "importerGeneralBEHeading",
            actionText: "B/E Heading",
            component: "textarea",
            width : "100%",
            height: 50
          },
        ],
        row14: [
          {
            name: "importerGeneralQuotation",
            label: "Quotation",
            component: "text-field",
            endIconName: "LuSearch",
          },
        ],
        row15: [
          {
            name: "importerGeneralSalesPerson",
            label: "Sales Person",
            component: "text-field",
            endIconName: "LuChevronDown",
            width: "90%",
            disabled: true,
          },
          {
            name: "Sales Person",
            component: "outlinebutton",
            variant: "bodySmallMedium",
            width: "10%",
            iconName: BsThreeDots,
            iconSpacing: 0,
            iconPosition: "center",
            sx: {
              mt: "32px",
            },
            disabled: true,

          },
        ],
        row16: [
          {
            name: "importerGeneralPaymentMethod",
            label: "Payment Method",
            component: "dropdown",
            endIconName: "LuChevronDown",
            width: "50%",
            options: [
              {label : "Transaction", value : "Transaction"},
              {label : "Deferred",value : "Deferred"}
            ]
          },
          {
            name: "importerGeneralClearedUnderRMS",
            checkboxLabel: "Cleared Under RMS",
            component: "checkboxbox",
            endIconName: "LuChevronDown",
            width: "50%",
            sx: {
              height: 67,
              alignItems: "end",
            }
          }
        ],
        row17: [
          {
            name: "importerGeneralUCRType",
            label: "UCR Type & No",
            component: "text-field",
            width: "40%"
          },
          {
            name: "importerGeneralUCRTypeNo",
            component: "text-field",
            width: "60%"
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "50%",
      rows: {
        row1: [
          {
            name: "importerGeneralRefType",
            label: "Ref. Type",
            component: "text-field",
            // sx: {
            //   marginTop: "13.5px",
            // },
            placeholder: "Enter the Ref Type",
          //   options : [
          //     {
          //       value: "Job Order",
          //       label: "Job Order"
          //     },
          //     {
          //       value : "Shipment",
          //       label : "Shipment"
          //     }
          // ]
          },
          {
            name: "importerGeneralRefTypeDate",
            label: "",
            component: "text-field",
            // styles: {
            //   marginTop: "13px",
            // },
            placeholder: "Search Importer",
            icon: LuSearch,
            disabled: true

          },
        ],
        row2: [
          {
            name: "importerGeneralDocFillingStatus",
            label: "Doc Filling Status",
            component: "dropdown",
            placeholder: "Normal",
            options: [
              { label: "Normal", value: "Normal" },
              { label: "Prior", value: "Prior" },
            ]
          },
          {
            name: "importerGeneralTranshipment",
            label: "Transhipment",
            component: "dropdown",
            placeholder: "No",
            options:[
              {label : "Yes", value : "Yes"},
              {label : "No", value : "No"}
            ]
          },
        ],

        row3: [
          {
            name: "importerGeneralSpecialPermission",
            actionText: "Special Permisson",
            component: "textarea",
            width: "100%",
            height: 60,
            sx: {
              borderRadius: 10,
            },
            alwaysSend: true,   // ✅🔥 VERY IMPORTANT

          },
          {
            name: "importerGeneralSpecialPermissionButton",
            component: "outlinebutton",
            sx: {
              mt: "50px",
            },
            width: "10%",
            iconName: BsThreeDots,
            iconSpacing: 0,
            iconPosition: "center",
            action: "openSubDialog",
            subComponent: "SpecialPermission",

          },
        ],

        row4: [
          {
            name: "importerGeneralBENumber",
            label: "BE Number/Date",
            component: "text-field",
            placeholder: "Enter BE No",
          },
          {
            name: "importerGeneralBENumberDate",
            component: "dateselector",
            // disabled: true,
            dependsOn:"importerGeneralBENumber"
          },
        ],
        row5: [
          {
            name: "importGeneralIsHighSeaSale",
            checkboxLabel: "High Sea Sale",
            width: "25%",
            component: "checkboxbox",
          },
        ],
        row6: [
          {
            name: "importGeneralHSSLevel0",
            label: "Level 0",

            component: "text-field",
            defaultValue:0,
            // placeholder: "Enter the Level",
          },
        ],
        row7: [
          {
            name: "importGeneralHSSSellerName",
            label: "Seller Name",
            component: "text-field",
            icon: LuSearch,
            placeholder: "Enter the SellerName",
            dependsOn: "importGeneralIsHighSeaSale",
            type : "autocomplete",
            endpoint : "getCustomers",
            autofillTargets : {
              importerGeneralHSSAddressId : "address"              
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row8: [
          {
            name: "importerGeneralHSSAddressId",
            label: "Address",
            component: "dropdown",
            endIconName: "LuChevronDown",
            width: "100%",
            type : "autocomplete",
            autofillTargets: {
              address: "addressLine",
              importerGeneralHSSBranchSNO: "branchNo",
              importerGeneralHSSIECodeNo: "ieCodeNo",
              importerGeneralHSSCity: "city",
              importerGeneralHSSCountry: "country",
              importerGeneralHSSPostalCode: "pincode"
            },

          },
        ],
        row9: [
          {
            name: "address",
            component: "textarea",
            width : "100%",
            sx: {
              height: 60
            }

          },
        ],
        row10: [
          {
            name: "importerGeneralHSSBranchSNO",
            label: "Branch SNo",
            component: "text-field",
          },
          {
            name: "importerGeneralHSSIECodeNo",
            label: "IE Code No",
            component: "text-field",
          },
        ],
        row11: [
          {
            name: "importerGeneralHSSCity",
            label: "City",
            component: "text-field",
            dependsOn: "importGeneralIsHighSeaSale",


          },
          {
            name: "importerGeneralHSSPostalCode",
            label: "Postal Code",
            component: "text-field",
            dependsOn: "importGeneralIsHighSeaSale",
          },
        ],
        row12: [
          {
            name: "importerGeneralHSSCountry",
            label: "Country",
            component: "text-field",
            endIconName: "LuChevronDown",
            type : "autocomplete",
            endpoint : "getCountry",
            icon : LuSearch
          },
        ],
        row13: [
          {
            name: "importerGeneralHSSADCode",
            label: "AD Code",
            component: "text-field",
            endpoint : "getAdCodeMaster",
            type : "autocomplete"
          },
        ],
        row14: [
          {
            name: "More High Sea Seller",
            label: "More High Sea Seller",
            component: "backlink",
            action: "openSubDialog",
            subComponent: "ImportHighSeaSeller",
            dependsOn: "importGeneralIsHighSeaSale",
          },
        ],
        row15: [
          {
            name: "Note details",
            actionText: "Note: Items in italic indicates the fields which are used for EDI file submission",
            component: "typographytext",
            sx: {
              fontWeight: "bold",
            },
            actionTextSx: { fontWeight: 600 },

          }
        ],
      },
    },
  ]
};
